import { STROKE_WIDTH, SVG_H, SVG_W, TRUNK_X } from './tree.consts';

interface TreeTrunkProps {
  left: number;
}

const TreeTrunk = ({ left }: TreeTrunkProps) => (
  <svg
    width={SVG_W}
    height="100%"
    viewBox={`0 0 ${SVG_W} ${SVG_H}`}
    preserveAspectRatio="none"
    style={{
      position: 'absolute',
      left,
      top: 0,
      pointerEvents: 'none',
      overflow: 'visible',
    }}
  >
    <path
      d={`M${TRUNK_X},${-SVG_H} L${TRUNK_X},${SVG_H}`}
      stroke="currentColor"
      strokeWidth={STROKE_WIDTH}
      fill="none"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export default TreeTrunk;
